module.exports = __webpack_public_path__ + "static/media/home-test.242bb8bd.svg";